import $ from 'jquery'
import 'owl.carousel';
import { trace } from 'rytm-helpers';


/**
 * Owl carousel with GALLERY / THUMBS roles
 * ref: https://codepen.io/pankajthakur/pen/yVrXxj
 */

const CAROUSEL_SELECTOR = ".rowl-carousel"

let list = []
let currentIndex = 0

const getCarouselParamsResponsive = (el) => {
  switch (el.dataset.items) {
    case "1":
      return {
        0: {
          items: 1,
        }
      }
    case "2":
      return {
        0: {
          items: 1,
        },
        576: {
          items: 2,
        },
        768: {
          items: 2,
        },
        992: {
          items: 2,
        },
        1200: {
          items: 2,
        },
      }
    case "3":
      return {
        0: {
          items: 1,
        },
        576: {
          items: 2,
        },
        768: {
          items: 3,
        },
      }      
    case "4":
      return {
        0: {
          items: 1,
        },
        576: {
          items: 2,
        },
        768: {
          items: 3,
        },
        992: {
          items: 4,
        },
        1200: {
          items: 4,
        },
      }
    case "8":
      return {
        0: {
          items: 2,
        },
        576: {
          items: 4,
        },
        768: {
          items: 6,
        },
        992: {
          items: 8,
        },
        1200: {
          items: 8,
        },
      } 
    case "10":
      return {
        0: {
          items: 4,
        },
        400: {
          items: 5,
        },
        576: {
          items: 6,
        },
        768: {
          items: 8,
        },
        992: {
          items: 10,
        },
      } 
    default:
      return {
        0: {
          items: 2,
        },
        576: {
          items: 4,
        },
        768: {
          items: 4,
        },
        992: {
          items: 6,
        },
        1200: {
          items: 6,
        },
      }
  }
}
const getCarouselParams = (el) => {
  const autoplay = el.dataset.autoplay == "true" ? true : false
  const autowidth = el.dataset.autowidth ? true : false
  const nav = el.dataset.hideNav ? false : true
  // const sufix = el.dataset.navWhite == "true" ? "_white"  : "_black"
  const sufix = ""
  const loop = el.dataset.loop ? el.dataset.loop !== "false"  : true
  const center = el.dataset.center ? el.dataset.center == "true"  : false
  const margin = el.dataset.margin ? parseInt(el.dataset.margin)  : 0
  const startPosition = el.dataset.openTo ? parseInt(el.dataset.openTo)  : 0
  return {
    nav,
    navText: [
      '<img src="/local/images/owl' + sufix + '_prev.svg" alt="poprzedni" />', 
      '<img src="/local/images/owl' + sufix + '_next.svg" alt="następny" />'
    ],
    loop,
    // stagePadding: el.offsetWidth * .3,
    center,
    startPosition,
    margin,
    dots: false,
    autoplay,
    // slideTransition: "linear",
    autoplayTimeout: 3500,
    autoplayHoverPause: false,
    autoplaySpeed: 3500,
    autowidth,
    responsive: getCarouselParamsResponsive(el)
  }
}

const getCarouselRole = ($carousel) => {
  return $carousel ? $carousel.get(0).dataset.carouselRole : null
}
const getCarouselByRole = (role, id) => {
  let result = null
  list.forEach(($carousel, index) => {
    if (getCarouselRole($carousel) == role && $carousel.get(0).dataset.galleryId == id) {
      result = $carousel
      return result
    }
  })
  return result
}

const getCurrentGalleryIndex = (item) => {
  let count = item.count - 1;
  let current = Math.round(item.index - item.count / 2 - 0.5);
  if (current < 0) {
    current = count;
  }
  if (current > count) {
    current = 0;
  }
  return current
}

const syncGallery = (e) => {
  const current = getCurrentGalleryIndex(e.item)
  const cId = e.currentTarget.dataset.galleryId
  const $carouselThumbs = getCarouselByRole("thumbs", cId)
  if ($carouselThumbs) {
    $carouselThumbs
      .find(".owl-item")
      .removeClass("current")
      .eq(current)
      .addClass("current");
    var onscreen = $carouselThumbs.find(".owl-item.active").length - 1;
    var start = $carouselThumbs
    .find(".owl-item.active")
    .first()
    .index();
    var end = $carouselThumbs
    .find(".owl-item.active")
    .last()
    .index();

    if (current > end) {
      $carouselThumbs.data("owl.carousel").to(current, 100, true);
    }
    if (current < start) {
      $carouselThumbs.data("owl.carousel").to(current - onscreen, 100, true);
    }
  }
}
const syncThumbs = (e) => {
  // console.log("SYNC THUMB:", e)
}
const onThumbClick = (e) => {
  e.preventDefault();
  const index = $(e.currentTarget).index();
  const cId = e.currentTarget.closest(CAROUSEL_SELECTOR).dataset.galleryId
  const $carousel = getCarouselByRole("gallery", cId)
  if ($carousel) {
    $carousel.data("owl.carousel").to(index, 300, true)
  }
}
const initializedGallery = (e) => {
  currentIndex = getCurrentGalleryIndex(e.item)
}
const initializedThumbs = (e) => {
  setTimeout(() => {
    // console.log("INITIALIZED THUMBS", currentIndex)
    let $carousel = $(e.currentTarget)
    $carousel.data("owl.carousel").to(currentIndex, 300, true)
    $carousel.find(".owl-item").eq(currentIndex).addClass("current");
  }, 200)
}

const initOwlCarousel = (el, index) => {
  // trace("init owl", el)
  let $carousel = $(el)
  $carousel.addClass('owl-carousel')
  switch (getCarouselRole($carousel)) {
    case "gallery":
      $carousel.on("initialized.owl.carousel", initializedGallery)
      $carousel.on("changed.owl.carousel", syncGallery)
      break;
    case "thumbs":
      $carousel.on("initialized.owl.carousel", initializedThumbs)
      $carousel.on("changed.owl.carousel", syncThumbs)
      $carousel.on("click", ".owl-item", onThumbClick)
      break;
  }
  $carousel.owlCarousel(getCarouselParams(el))
  list.push($carousel)
}
const destroyOwlCarousel = ($carousel, index) => {
  // trace("destroy carousel", $carousel)
  $carousel.trigger('destroy.owl.carousel').removeClass('owl-carousel owl-loaded')
  $carousel.find('.owl-stage-outer').children().unwrap()
}

export const destroyOwl = () => {
  list.forEach(destroyOwlCarousel)
  list = []
}
export const buildOwl = () => {
  const list = [...document.querySelectorAll(CAROUSEL_SELECTOR)]
  list.forEach(initOwlCarousel)
}